import { useRecaptchaService } from "@recaptcha/useRecaptchaService";
import { useRecaptchaV3 } from "@recaptcha/useRecaptchaV3";

type HandleRecaptcha = (recaptchaV2Response?: string) => Promise<void>;

const useHandleRecaptcha = (action: string): HandleRecaptcha => {
  const { generateRecaptchaToken } = useRecaptchaV3();
  const { evaluateBotScore } = useRecaptchaService();

  const handleRecaptcha: HandleRecaptcha = async (recaptchaV2Response) => {
    const token = recaptchaV2Response || (await generateRecaptchaToken(action));
    if (token) {
      await evaluateBotScore(action, token);
    }
  };

  return handleRecaptcha;
};

export default useHandleRecaptcha;
